import { enumSnackbarStatusType } from "../../../../types/enums";
import { StoreActionType as Type } from "../../types";

type SnackbarProps = {
  open: boolean;
  message: string;
  duration: number;
  status : enumSnackbarStatusType
};

const initialState: SnackbarProps = {
  open: false,
  message: "",
  duration: 2000,
  status: enumSnackbarStatusType.info
};

export const snackbarReducer = (state = initialState, action: any) => {

  const { payload } = action

  switch (action.type) {
    case Type.SHOW_SNACKBAR:
      return {
        ...state,
        open: true,
        message: payload?.message,
        duration: payload?.duration ?? initialState.duration,
        status: payload?.status
      };
    case Type.HIDE_SNACKBAR:
      return {
        ...state,
        open: false,
        message: "",
        duration: initialState.duration,
      };
    default:
      return state;
  }
};